import type React from 'react';
import { Text } from '../ui/text';

interface AuthPanelProps {
  eyebrow: string;
  title: string;
  body: string;
  children: React.ReactNode;
}

export default function AuthPanel({ eyebrow, title, body, children }: AuthPanelProps) {
  return (
    <div className="mx-auto grid w-full max-w-5xl overflow-hidden rounded-xl border border-zinc-800 bg-zinc-900 shadow-2xl shadow-black/20 lg:grid-cols-[minmax(0,1fr)_24rem]">
      <section className="p-6 sm:p-10">
        <Text className="text-sm font-medium uppercase tracking-[0.18em] text-emerald-300">
          {eyebrow}
        </Text>
        <h1 className="mt-3 max-w-xl text-3xl/9 font-semibold text-white">{title}</h1>
        <Text className="mt-3 max-w-lg text-zinc-300">{body}</Text>
        <div className="mt-8">{children}</div>
      </section>

      <aside className="relative hidden min-h-[520px] overflow-hidden border-l border-zinc-800 bg-zinc-950 p-8 lg:block">
        <div className="absolute inset-0 bg-[linear-gradient(135deg,rgba(16,185,129,0.22),rgba(24,24,27,0.18)_45%,rgba(14,116,144,0.2)),linear-gradient(90deg,rgba(255,255,255,0.1)_1px,transparent_1px),linear-gradient(0deg,rgba(255,255,255,0.08)_1px,transparent_1px)] bg-[size:auto,64px_64px,64px_64px]" />
        <div className="relative flex h-full flex-col justify-between">
          <div>
            <div className="inline-flex rounded bg-white/10 px-2 py-1 text-xs font-medium text-emerald-200">
              GAME DAY
            </div>
            <h2 className="mt-5 max-w-xs text-2xl/8 font-semibold text-white">
              One clean place for stream access.
            </h2>
          </div>

          <div className="rounded-lg border border-white/10 bg-zinc-950/75 p-4 backdrop-blur">
            <div className="flex items-center justify-between text-xs text-zinc-400">
              <span>Next live game</span>
              <span className="text-emerald-300">Ready</span>
            </div>
            <div className="mt-4 text-lg font-semibold text-white">RA Legends 10u</div>
            <div className="mt-1 text-sm text-zinc-400">Private links, approved fans, easy replays.</div>
            <div className="mt-5 grid grid-cols-3 gap-2 text-center text-xs text-zinc-400">
              <div className="rounded bg-white/5 py-2">
                <span className="block text-zinc-100">Live</span>
                Live
              </div>
              <div className="rounded bg-white/5 py-2">
                <span className="block text-zinc-100">Replay</span>
                Replay
              </div>
              <div className="rounded bg-white/5 py-2">
                <span className="block text-zinc-100">Family</span>
                Access
              </div>
            </div>
          </div>
        </div>
      </aside>
    </div>
  );
}
